import { BankOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React, { FunctionComponent, memo } from 'react'

import { useMunicipalOfficeNameByAdresnimistokodQuery } from '../../../graphql/generated'

export interface MunicipalOfficeIndicatorProps {
  addressId?: string | number
  className?: string
}

export const MunicipalOfficeIndicator: FunctionComponent<MunicipalOfficeIndicatorProps> =
  memo(({ addressId, className = 'mr-1 text-gray-400' }) => {
    const [{ data }] = useMunicipalOfficeNameByAdresnimistokodQuery({
      pause: !addressId,
      variables: { adresnimistokod: addressId ? addressId.toString() : '' },
    })

    if (!addressId) return null

    const officeName = data?.municipalOfficeByAdresnimistokod?.officeName
    if (!officeName) return null

    const tooltip = `Adresa shodná s adresou obecního úřadu ${officeName}`

    return (
      <Tooltip title={tooltip}>
        <BankOutlined className={className} />
      </Tooltip>
    )
  })
